export default {
  hjid: Number(process.env.REACT_APP_HOTJAR_ID),
  hjsv: Number(process.env.REACT_APP_HOTJAR_SNIPPET_VERSION),
}
